import { ActivityEntityName } from '../../../../entities';
import { MergeField, MergeSchema, getSchema } from '../../decorators';
import { StageMergeData } from './stage.merge.data';
import { StageItemMergeData } from './stage.items.merge.data';

@MergeSchema({
    entity: ActivityEntityName.WorkOrder,
    name: 'StageIncludeItemsMergeDataSchema',
})
export class StageIncludeItemsMergeData extends StageMergeData {
    @MergeField({
        arraySchemaName: 'StageItemsMergeSchema'
    })
    items: StageItemMergeData[] = [];
}

export const StageIncludeItemsMergeDataSchema = getSchema(StageIncludeItemsMergeData)